import React, { useEffect, useState } from 'react'

export const useTap = (
  ref: React.RefObject<HTMLElement | null>,
  onTap: () => void,
  enabled?: boolean,
) => {
  const [isTapped, setIsTapped] = useState(false)
  const [position, setPosition] = useState<[number, number] | null>(null)
  const delta = 10

  useEffect(() => {
    const element = ref?.current

    if (!element || !enabled) return

    const handleTouchStart = (e: TouchEvent) => {
      setPosition([e.touches[0].screenX, e.touches[0].screenY])
      setIsTapped(true)
    }
    const handleTouchEnd = (e: TouchEvent) => {
      if (!e.changedTouches[0]) {
        setIsTapped(false)
        setPosition(null)
        return
      }

      const isTapped =
        position &&
        Math.abs(position[0] - e.changedTouches[0].screenX) < delta &&
        Math.abs(position[1] - e.changedTouches[0].screenY) < delta

      if (isTapped) {
        e.preventDefault()
        onTap()
      }
      setPosition(null)
      setIsTapped(false)
    }

    element.addEventListener('touchstart', handleTouchStart)
    element.addEventListener('touchend', handleTouchEnd)

    return () => {
      element.removeEventListener('touchstart', handleTouchStart)
      element.removeEventListener('touchend', handleTouchEnd)
    }
  }, [ref, onTap, enabled])
}
